export default {
  hero: {
    title1: 'YOYBUY Spreadsheet',
    title2: 'Удобная система покупок из Китая',
    subtitle: 'Сравнивайте товары, оформляйте заказы и экономьте на доставке через удобные таблицы',
    ctaPrimary: 'YOYBUY Sheet',
    ctaSecondary: 'Buy It Now',
    socialProof: 'Более 10 000 довольных покупателей',
  },
  categories: {
    title1: 'Все товарные',
    title2: 'категории',
    description: 'Выбирайте из широкого ассортимента товаров, доступных для заказа через нашу систему spreadsheet. От брендовой обуви до аксессуаров — всё, что вам нужно, в одном месте.',
  },
  showcase: {
    title1: 'Популярные',
    title2: 'товары',
    highlight: 'YOYBUY',
    subtitle: 'Лучшие предложения этой недели — подборка самых востребованных позиций',
    badge: 'YOYBUY Sheet',
  },
  about: {
    label: 'О СИСТЕМЕ YOYBUY SHEET',
    title: 'Что такое YOYBUY Spreadsheet и почему это лучший способ покупать из Китая',
    paragraph1: 'YOYBUY Spreadsheet — это современная система покупок через китайские маркетплейсы Taobao и Weidian. Она позволяет сравнивать товары в удобных таблицах, заказывать без прямого доступа к сайту продавца и использовать агентскую систему покупок, которая экономит ваши деньги на доставке и комиссиях.',
    paragraph2: 'В отличие от обычных агентов, YOYBUY Spreadsheet даёт вам полный контроль над заказом: вы видите все детали, цены и статусы в реальном времени. Это прозрачно, быстро и невероятно удобно для тех, кто ценит своё время и деньги.',
    paragraph3: 'Система идеально подходит как для опытных байеров, так и для новичков, которые только начинают знакомство с китайскими маркетплейсами. Простой интерфейс, понятная логика и поддержка на каждом этапе делают YOYBUY Spreadsheet выбором номер один.',
    btnGuide: 'YOYBUY Sheet: Полное руководство',
    btnHowTo: 'Как заказать через YOYBUY Sheet',
  },
  testimonial: {
    quote: '«YOYBUY Spreadsheet полностью изменил мой подход к закупкам из Китая. Раньше я тратил часы на поиск и сравнение товаров, а теперь всё организовано в одной удобной таблице. Экономия времени и денег — просто невероятная.»',
    name: 'Алексей Морозов',
    role: 'Владелец интернет-магазина',
    cta: 'Попробовать YOYBUY',
  },
  finalCta: {
    title1: 'Готовы начать',
    title2: 'покупать',
    title3: 'выгодно?',
    desc: 'Присоединяйтесь к тысячам покупателей, которые уже выбрали YOYBUY Spreadsheet',
    cta: 'Перейти на YOYBUY Sheet',
  },
};